import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface UserProgressData {
  xp: number;
  level: number;
  streak: number;
  badgeCount: number;
  badges: Array<{
    id: string;
    badge_slug: string;
    earned_at: string;
  }>;
}

export const useUserProgress = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['user-progress', userId],
    queryFn: async (): Promise<UserProgressData | null> => {
      if (!userId) return null;

      // Fetch user XP and level
      const { data: xpData } = await supabase
        .from('user_xp')
        .select('xp, level')
        .eq('user_id', userId)
        .maybeSingle();

      // Fetch user streak
      const { data: streakData } = await supabase
        .from('user_streaks')
        .select('current_streak')
        .eq('user_id', userId)
        .maybeSingle();

      // Fetch user badges
      const { data: badgesData } = await supabase
        .from('user_badges')
        .select('id, badge_slug, earned_at')
        .eq('user_id', userId)
        .order('earned_at', { ascending: false });

      return {
        xp: xpData?.xp || 0,
        level: xpData?.level || 0,
        streak: streakData?.current_streak || 0,
        badgeCount: badgesData?.length || 0,
        badges: badgesData || []
      };
    },
    enabled: !!userId
  });
};